import(/* webpackMode: "eager" */ "/codebuild/output/src211455154/src/apps/web/app/[locale]/error.tsx");
